/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {ModalProductHeader} from "../../organisms/products/ModalProductHeader";
import {Divider} from "../../atoms/layout/Divider";
import {Modal} from "../../atoms/bootstrap/Modal";
import React from "react";
import {useI18N} from "../../hoc/withI18N";

export function ProductModalBody({isPricingVatIncluded, children, addAll}) {
    const translate = useI18N();

    return <Modal.Body className={"ordering-modal__body"}>
        <ModalProductHeader translate={translate} addAll={addAll}/>
        <Divider/>
        {children}
        {isPricingVatIncluded && <div className={"p-padding-left-md p-padding-right-md p-padding-bottom-xs"}>
            <span className="p-vat-text">{translate("Prices are incl. VAT")}</span>
        </div>}
    </Modal.Body>
}
